import * as React from 'react';
import { connect } from 'react-redux';
import PrintButton from 'src/components/utils/PrintButton/PrintButton';
import { ApplicationState } from 'src/store';
import { IEventData } from 'src/store/events/types';
import { Season } from 'src/store/season/types';
import { Section } from 'src/store/sections/types';
import { User } from 'src/store/user/types';
import { calculateWeeks, toggleWeek } from 'src/store/weeks/actions';
import { IWeekData, Week } from 'src/store/weeks/types';
import WeekView from '../WeekView/WeekView';
import WeekViewPrint from '../WeekView/WeekViewPrint/WeekViewPrint';
import './WeekList.scss';

interface PropsFromDispatch {
  calculateWeeks: typeof calculateWeeks;
  toggleWeek: typeof toggleWeek;
}

interface PropsFromState {
  user?: User;
  weeks: IWeekData;
  events: IEventData;
}

interface Props {
  season: Season;
  section: Section;
}

interface State {
  printing: number;
}

type AllProps = Props & PropsFromDispatch & PropsFromState;

class WeekList extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);

    this.state = {
      printing: -1
    };

    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(mql => {
        if (!mql.matches) {
          this.afterPrint();
        }
      });
    }

    window.onafterprint = this.afterPrint;

    this.weekOnClick = this.weekOnClick.bind(this);
    this.renderWeek = this.renderWeek.bind(this);
  }

  afterPrint = () => {
    console.log('Functionality to run after printing');
    this.onPrintFinished();
  };

  public componentDidMount() {
    const weeks = this.props.weeks.bySeasonId[this.props.season.id];
    if (!weeks) {
      if (this.props.user) {
        if (this.props.user.role.seeUpTo !== -1) {
          this.props.calculateWeeks(this.props.season, this.props.user.role.seeUpTo);
        } else {
          this.props.calculateWeeks(this.props.season);
        }
      }
    }
  }

  public render() {
    const { weeks, season } = this.props;
    const seasonWeeks = weeks.bySeasonId[season.id];
    return (
      <React.Fragment>
        <div className="week_list container">
          <ul>{seasonWeeks && seasonWeeks.map(this.renderWeek)}</ul>
        </div>
      </React.Fragment>
    );
  }

  onPrint = (id: number) => {
    this.setState({ printing: id }, () => {
      window.print();
    });
  };

  onPrintFinished = () => {
    this.setState({ printing: -1 });
  };

  private renderWeek = (weekId: number, index: number) => {
    const week = this.props.weeks.byId[weekId];
    const onClick = this.weekOnClick.bind(this, week);
    return (
      <React.Fragment key={index}>
        <li className={week.open ? 'open' : ''}>
          {this.state.printing !== week.id && (
            <React.Fragment>
              <span onClick={onClick} className="pointer">
                {week.startDate.format('DD.MM')} - {week.endDate.format('DD.MM.YYYY')}
              </span>
              {week.open && (
                <PrintButton
                  onClick={this.onPrint.bind(this, week.id)}
                  style={{ position: 'relative', height: '25px', float: 'left' }}
                  className="noAnim"
                  title="Wochenplan drucken"
                />
              )}
              {week.open && <WeekView week={week} sectionTitle={this.props.section.title} />}
            </React.Fragment>
          )}
        </li>
        {this.state.printing === week.id && this.props.user && this.props.events && (
          <WeekViewPrint week={week} events={this.props.events} user={this.props.user} />
        )}
      </React.Fragment>
    );
  };

  private weekOnClick(week: Week) {
    this.props.toggleWeek(week.id);
  }
}

const mapStateToProps = ({ auth, weeks, events }: ApplicationState) => ({
  user: auth.data,
  weeks: weeks.data,
  events: events.data
});

const mapDispatchToProps = (dispatch: any) => ({
  calculateWeeks: (season: Season, seeUpTo?: number) => dispatch(calculateWeeks(season, seeUpTo)),
  toggleWeek: (weekId: number) => dispatch(toggleWeek(weekId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WeekList);



// WEBPACK FOOTER //
// ./src/components/Week/WeekList/WeekList.tsx